import './PresentationDetailPage.css'

import { Tab } from 'material-ui/Tabs'
import { compose, withProps } from 'recompose'
import React from 'react'
import { withRouter } from 'react-router-dom'

import { trackEvent } from '../../app/ga'
import {
  getAppTitle,
  getChatCfg,
  getPresentation,
  getPresentationChatroom,
} from '../../app/selectors'
import PresentationChat from './PresentationChat'
import Msg from '../../components/Msg'
import PresentationNotes from './PresentationNotes'
import NavigationTabs from '../../components/NavigationTabs'
import PresentationContent from './PresentationContent'
import content from '../../content'
import muiThemeable from 'material-ui/styles/muiThemeable'

function PresentationDetailPage({
  appTitle,
  presentation,
  chatCfg,
  chatroom,
  muiTheme,
}) {
  if (!presentation) {
    return null
  }
  const showChat = !!(chatCfg && chatroom)
  // TODO: make 15px spacing between buttons (mainly the underline)
  const { tabButton: buttonStyle } = muiTheme
  return (
    <NavigationTabs initialSelectedIndex={0}>
      <Tab
        label={<Msg id="PresentationDetail.tab.detail" />}
        buttonStyle={buttonStyle}
      >
        <PresentationContent presentation={presentation} />
      </Tab>
      <Tab
        label={<Msg id="PresentationDetail.tab.notes" />}
        onActive={() => trackEvent('notes', 'display', presentation.title)}
        buttonStyle={buttonStyle}
      >
        <PresentationNotes presentation={presentation} appTitle={appTitle} />
      </Tab>
      {showChat && (
        <Tab
          label={<Msg id="PresentationDetail.tab.chat" />}
          onActive={() => trackEvent('chat', 'display', presentation.title)}
          buttonStyle={buttonStyle}
        >
          <PresentationChat
            presentation={presentation}
            appId={chatCfg.appId}
            room={chatroom}
          />
        </Tab>
      )}
    </NavigationTabs>
  )
}

const withPageContent = withProps(ownProps => ({
  appTitle: getAppTitle(content),
  presentation: getPresentation(content, ownProps.match.params.id),
  chatroom: getPresentationChatroom(content, ownProps.match.params.id),
  chatCfg: getChatCfg(content),
}))

export default compose(withPageContent, withRouter, muiThemeable())(
  PresentationDetailPage
)



// WEBPACK FOOTER //
// ./src/containers/PresentationDetail/PresentationDetailPage.js